import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
import { Crime_Os_Common_FieldResponseFragmentDoc } from './fieldResponse.generatedTypes'
export type HandlePendingAction_FragmentFragment = {
  __typename: 'HandlePendingAction'
  handlePendingActionId: string
  sectionType: Types.HandleSectionTypeEnum
  name: string
  count: number
}

export type HandleDetails_FragmentFragment = {
  __typename: 'HandleDetails'
  recordId: string
  templateId: string
  title: string
  description?: string | null
  logoUrl?: string | null
  isBookmarked: boolean
  pendingActions: Array<{
    __typename: 'HandlePendingAction'
    handlePendingActionId: string
    sectionType: Types.HandleSectionTypeEnum
    name: string
    count: number
  }>
}

export type HandleGroup_FragmentFragment = {
  __typename: 'HandleGroup'
  handleGroupId: string
  name: string
  totalCount: number
  iconUrl?: string | null
  recordIds: Array<string>
}

export type HandleDetailsWithGroups_FragmentFragment = {
  __typename: 'HandleDetailsWithGroups'
  handleDetails: {
    __typename: 'HandleDetails'
    recordId: string
    templateId: string
    title: string
    description?: string | null
    logoUrl?: string | null
    isBookmarked: boolean
    pendingActions: Array<{
      __typename: 'HandlePendingAction'
      handlePendingActionId: string
      sectionType: Types.HandleSectionTypeEnum
      name: string
      count: number
    }>
  }
  groups: Array<{ __typename: 'HandleGroup'; handleGroupId: string }>
}

export type RecordFragment = {
  __typename: 'Record'
  recordId: string
  templateId: string
  createdAt: string
  fields: Array<{
    __typename: 'FieldResponse'
    fieldId: string
    fieldResponseId: string
    systemFieldEnum?: Types.SystemFieldEnum | null
    response?:
      | {
          __typename: 'BaseUser'
          userId: string
          profilePicUrl?: string | null
          email?: string | null
          userName?: string | null
        }
      | { __typename: 'GQLDateTimeType'; dateTime?: string | null }
      | { __typename: 'GQLDateType'; dateValue?: string | null }
      | { __typename: 'GQLFloatType'; floatValue?: number | null }
      | { __typename: 'GQLIntType'; integerValue?: number | null }
      | { __typename: 'GQLListStringType'; values: Array<string> }
      | { __typename: 'GQLStringType'; stringValue?: string | null }
      | { __typename: 'GQLTimeType'; timeValue?: string | null }
      | {
          __typename: 'LookupResponseType'
          lookupResponses: Array<{
            __typename: 'LookupResponse'
            label: string
            value: string
          }>
        }
      | {
          __typename: 'PhoneNumberResponse'
          dialCode: string
          iso2CountryCode?: string | null
          phoneNumber: string
        }
      | {
          __typename: 'Status'
          statusId: string
          name: string
          color?: Types.ColorEnum | null
          order: number
        }
      | null
  } | null>
  handleDetailsWithGroups?: {
    __typename: 'HandleDetailsWithGroups'
    handleDetails: {
      __typename: 'HandleDetails'
      recordId: string
      templateId: string
      title: string
      description?: string | null
      logoUrl?: string | null
      isBookmarked: boolean
      pendingActions: Array<{
        __typename: 'HandlePendingAction'
        handlePendingActionId: string
        sectionType: Types.HandleSectionTypeEnum
        name: string
        count: number
      }>
    }
    groups: Array<{ __typename: 'HandleGroup'; handleGroupId: string }>
  } | null
}

export const HandleGroup_FragmentFragmentDoc = gql`
  fragment HandleGroup_Fragment on HandleGroup {
    handleGroupId
    name
    totalCount
    iconUrl
    recordIds
  }
`
export const HandlePendingAction_FragmentFragmentDoc = gql`
  fragment HandlePendingAction_Fragment on HandlePendingAction {
    handlePendingActionId
    sectionType
    name
    count
  }
`
export const HandleDetails_FragmentFragmentDoc = gql`
  fragment HandleDetails_Fragment on HandleDetails {
    recordId
    templateId
    title
    description
    logoUrl
    isBookmarked
    pendingActions {
      ...HandlePendingAction_Fragment
    }
  }
  ${HandlePendingAction_FragmentFragmentDoc}
`
export const HandleDetailsWithGroups_FragmentFragmentDoc = gql`
  fragment HandleDetailsWithGroups_Fragment on HandleDetailsWithGroups {
    handleDetails {
      ...HandleDetails_Fragment
    }
    groups {
      handleGroupId
    }
  }
  ${HandleDetails_FragmentFragmentDoc}
`
export const RecordFragmentDoc = gql`
  fragment Record on Record {
    fields {
      ...Crime_Os_Common_FieldResponse
    }
    recordId
    templateId
    createdAt
    handleDetailsWithGroups {
      ...HandleDetailsWithGroups_Fragment
    }
  }
  ${Crime_Os_Common_FieldResponseFragmentDoc}
  ${HandleDetailsWithGroups_FragmentFragmentDoc}
`
